import '../../styles/Table.css'
import { useState, useEffect }  from 'react'
import vazio                    from '../../assets/caixa-vazia.png'
import loading                  from '../../assets/loading.gif'

function PermissionModuleTable ({ tableData, onSubmit }) {
    
    const [ checkBoxValues,  setCheckBoxValues   ] = useState({})    
    const [ isLoading,       setIsLoading        ] = useState(false)  

    useEffect(() => {

        const initialState = tableData.reduce((acc, data) => {
            
            acc[data.id] = {
                isAllowed: data.isAllowed || false 
            }

            return acc

        }, {});

        setCheckBoxValues(initialState);

    }, [tableData])

    const handleCheckBoxChange = (id, field) => {
        
        setCheckBoxValues((prev) => ({

            ...prev,
            
            [id]: {
                ...prev[id],
                [field]: !prev[id][field]   
            }
            
        }))
    }

    const handlerSubmit = async () => {
        
        setIsLoading(true);
      
        const updatedData = tableData.map((data) => ({
            ...data,
            isAllowed: checkBoxValues[data.id]?.isAllowed || false,
        }))
      
        await onSubmit(updatedData)
      
        setTimeout(() => {
            
            setIsLoading(false);
        
        }, 1500)
    
    }
      
    return (

        <section className='w-[100%]'>

            {tableData ?

                <table className='table-pattern-sistem w-[40%] borda-cinza mt-4'> 
                    
                    <thead className='bg-neutro'>
                        <tr>
                            <th></th>
                            <th className="!text-center">Permissão</th>
                        </tr>
                    </thead>
                    
                    <tbody>

                        {tableData.map((data)=>(
                            
                            <tr key={data.id}>
                                <td>{ data.ownerPermissionModule.name }</td>
                                <td>
                                    <div className="flex items-center">
                                        <input 
                                            id={`isAllowed-${data.id}`} 
                                            type="checkbox" 
                                            checked={checkBoxValues[data.id]?.isAllowed || false}
                                            onChange={() => {handleCheckBoxChange(data.id, "isAllowed")}}
                                            className="w-4 h-4 !m-auto !block ![appearance:auto] text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                                        />
                                    </div>
                                </td>
                            </tr>

                        ))}  
                         
                    </tbody>
                    
                </table>
            : 
                <div className='flex w-[100%] items-center justify-center pt-[30px]'>
                    <img alt="Vazio" width="150px" height="150px" src={vazio} />
                </div>
            }

            <footer>

                <button 
                    type="button" 
                    className="btn btn-azul-prof w-[40%] text-[1.125rem] mt-4 flex items-center justify-center"
                    onClick={handlerSubmit}
                    disabled={isLoading}
                >

                    {isLoading ? (
                        <img src={loading} alt="Carregando..." className="w-6 h-6" />
                    ) : (
                        "Salvar"
                    )}

                </button>
            </footer>
        </section>
    )
}

export default PermissionModuleTable;
